<template>
	<div style="background-color: #fff;margin: 10px;border-radius: 3px;">
		<div style="position: sticky;top:0;z-index: 999;background-color: #fff;padding-bottom: 1px;border-bottom: 1px solid #ebeef5;padding-top: 10px;">


			<!--带折叠的搜索start-->
			<div >
				<el-form size="mini" style="display: flex;flex-wrap: wrap;padding-left: 20px;" :style="{'height':isShowCollapse?'auto':'50px'}" ref="searchForm" :model="searchForm" inline label-width="120px">

					<!--收起时显示的搜索项start 4个搜索项为一行-->
					<div v-show="!isShowCollapse" style="width: 80%;display: flex;">

						<el-form-item label="状态" style="width: 23%;display: flex;">
							<!-- clearable -->
							<el-select v-model="searchForm.status"  placeholder="请选择">
								<el-option label="下架" :value="0" />
								<el-option label="上架" :value="1" />
							</el-select>
						</el-form-item>

						<!-- <el-form-item label="手机号" style="width: 23%;display: flex;">
							<el-input v-model="searchForm.mobile" placeholder="手机号" clearable size="mini" />
						</el-form-item> -->


					</div>
					<!--收起时显示的搜索项end-->

					<!--展开时显示的搜索项start 4个搜索项为一行-->
					<div v-if="isShowCollapse" style="display: flex;flex-wrap: wrap;">
						<el-form-item label="门店" style="width: 35%;display: flex;">
	
							<el-select v-model="searchForm.store_id" clearable placeholder="请选择">
								<el-option v-for="(item,index) in storeList" :label="item.name" :value="item.id" />
							</el-select>
						</el-form-item>

						<el-form-item label="手机号" style="width: 35%;display: flex;">
							<el-input v-model="searchForm.mobile" placeholder="手机号" clearable size="mini" />
						</el-form-item>


					</div>
					<!--展开时显示的搜索项end-->

					<div :style="{'width':isShowCollapse?'100%':'13%','justify-content': isShowCollapse?'flex-end':'center' }" style="height: 30px; display: flex;margin: 0;margin-bottom: 10px;">
						<!-- <div style="flex-shrink: 0;margin-right: 20px;display: flex;justify-content: center;align-items: center;cursor:pointer;color: #9A7E9C;font-size: 14px;line-height: 20px; display: flex;margin-left: 20px;" @click="isShowCollapseF()">
							<span v-if="!isShowCollapse">展开</span>
							<span v-else>收起</span>
							<span style="margin-left: 5px;font-size: 20px;line-height: 20px;" :style="{transform:isShowCollapse?'rotate(180deg)':'rotate(0deg)'}">∨</span>
						</div> -->
						<el-button round style="margin-right: 10px;" @click="handleSearch" type="primary" icon="el-icon-search" size="small">搜索</el-button>
						<el-button round @click="handleReset" size="small">重置</el-button>
						<div v-if="isShowCollapse" style="width: 70px;"></div>
					</div>


				</el-form>
			</div>
			<!--带折叠的搜索end-->

			<!-- 只允许单选的排序start margin-top: 10px;-->
			<div style="display: flex;align-items: center;background-color: #fff;margin-bottom: 15px; justify-content: space-between;">

				<div style="margin-right: 20px;margin-left: 35px;">
					<el-button @click="showAddOrEditTypePop" type="primary" round icon="el-icon-plus" size="mini">添加品牌</el-button>
				</div>

				<div v-if="false" class="sortLine" style="font-size: 14px;display: inline-flex; margin-left: 40px; color: #6f6c5f;background-color: #e0f7ed;border-radius: 8px;overflow: hidden;margin-right: 68px;">

					<div class="sortItem dis" @click="sort(-1)" :style="{color: sortIndex==-1?'#fff':'#777','font-weight': sortIndex==-1?'bold':'400','background-color': sortIndex==-1?'#9E819F':''}">
						默认</div>
					<!-- 排序项start -->
					<div class="sortItem dis" @click="sort(0,'updated_at')" :style="{color: sortIndex==0?'#fff':'#777','font-weight': sortIndex==0?'bold':'400','background-color': sortIndex==0?'#9E819F':''}">
						时间
						<img v-if="sortIndex==0&&sortContent=='asc'" :src="shang" style="width: 15px;height: 15px;margin-left: 3px;" />
						<img v-if="sortIndex==0&&sortContent=='desc'" :src="xia" style="width: 15px;height: 15px;margin-left: 3px;" />
					</div>
					<!-- 排序项end -->
					<div class="sortItem dis" @click="sort(1,'sales')" :style="{color: sortIndex==1?'#fff':'#777','font-weight': sortIndex==1?'bold':'400','background-color': sortIndex==1?'#9E819F':''}">
						销量
						<img v-if="sortIndex==1&&sortContent=='asc'" :src="shang" style="width: 15px;height: 15px;margin-left: 3px;" />
						<img v-if="sortIndex==1&&sortContent=='desc'" :src="xia" style="width: 15px;height: 15px;margin-left: 3px;" />
					</div>

					<div class="sortItem dis" @click="sort(2,'price')" :style="{color: sortIndex==2?'#fff':'#777','font-weight': sortIndex==2?'bold':'400','background-color': sortIndex==2?'#9E819F':''}">
						售价
						<img v-if="sortIndex==2&&sortContent=='asc'" :src="shang" style="width: 15px;height: 15px;margin-left: 3px;" />
						<img v-if="sortIndex==2&&sortContent=='desc'" :src="xia" style="width: 15px;height: 15px;margin-left: 3px;" />
					</div>

				</div>


			</div>
			<!-- 只允许单选的排序end -->
		</div>





		<!--表格start :height="tableHeight+'px'"-->
		<el-table :height="tableHeight" :show-header="false" ref="table" :data="tableData" style="width: 100%;background-color: #fff;margin: 5px;">

			<el-table-column style="width: 100%;">
				<template slot-scope="{ row, index }">
					<div class="tableTem" style="display: flex;margin-left: 20px;">
						<div class="avatar">

							<!--品牌图片start-->
							<div style="text-align: center;" class="dis">
								<img :src="row.image" style="width:70px;height:70px;cursor: pointer;" @click="handlePreView(row.image)">
								<!-- <div class="titleFont">主图</div> -->
							</div>
							<!--品爱图片end-->
							<!-- 
							<div style="width: 180px;">

								
								<div style="display: flex;">
									<span class="titleFont" style="width: 70px;text-align: right;">id：</span>
									<el-tooltip :content="row.id+''" placement="right">
										<div class="dian dianL">{{row.id}}</div>
									</el-tooltip>
								</div>
								
								<div style="display: flex;">
									<span class="titleFont" style="width: 70px;text-align: right;">名称：</span>
									<el-tooltip :content="row.name" placement="right">
										<div class="dian dianL">{{row.name}}</div>
									</el-tooltip>
								</div>

							</div> -->
						</div>

						<!-- height: 50px; -->
						<ul :style="{'width':isMobile?mobileWidth+'px':'','overflow-x':isMobile?'auto':'','overflow-y':isMobile?'hidden':'','flex-wrap':isMobile?'nowrap':''}">

							<li>
								<div class="content">
									<el-tooltip :content="row.id+''" placement="right">
										<div class="dian">{{row.id}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont">id</div>
							</li>

							<li style="width: 250px;">
								<div class="content" style="width: 240px;">
									<el-tooltip :content="row.name+''" placement="right">
										<div class="dian"  style="width: 240px;">{{row.name}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont">名称</div>
							</li>


							<li>
								<div class="content">
									<el-tooltip :content="row.sort+''" placement="right">
										<div class="dian">{{row.sort}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont">排序</div>
							</li>



							<li>
								<el-tooltip :content="row.created_at+''" placement="right">

									<div class="content dis">
										{{row.created_at | timeBreak2}}
									</div>
								</el-tooltip>
								<div class="titleFont dian">创建时间</div>
							</li>

							<li>
								<el-tooltip :content="row.updated_at+''" placement="right">

									<div class="content dis">
										{{row.updated_at | timeBreak2}}
									</div>
								</el-tooltip>
								<div class="titleFont dian">更新时间</div>
							</li>

						</ul>


						<div style="width: 100px;display: flex;justify-content: start;align-items: center;margin-left: 10px;">
							<el-dropdown trigger="hover" style="width: 80px;">
								<el-button size="mini" round type="primary">
									操作<i class="el-icon-arrow-down el-icon--right"></i>
								</el-button>
								<el-dropdown-menu slot="dropdown">

									<!-- <el-dropdown-item>
										<el-button type="danger" size="mini" round @click="showGoodsDetail(row)">查看
										</el-button>
									</el-dropdown-item> -->
									<el-dropdown-item>
										<el-button type="success" size="mini" round @click="showEditBrand(row)">编辑
										</el-button>
									</el-dropdown-item>
									
									
									<el-dropdown-item v-if="row.deleted_at!=null">
										<el-button type="warning" size="mini" round @click="statusChange(row,1)">上架
										</el-button>
									</el-dropdown-item>
									
									<el-dropdown-item v-if="row.deleted_at==null">
										<el-button type="warning" size="mini" round @click="statusChange(row,0)">下架
										</el-button>
									</el-dropdown-item>


									<!-- 					<el-dropdown-item>
										<el-button type="info" size="mini" round @click="showDetailDrawer(row)">查看
										</el-button>
									</el-dropdown-item>
									<el-dropdown-item>
										<el-button type="warning" size="mini" round @click="showDetailDrawer(row)">查看
										</el-button>
									</el-dropdown-item> -->


								</el-dropdown-menu>
							</el-dropdown>

						</div>


					</div>

				</template>
			</el-table-column>
		</el-table>
		<!--表格end-->

		<!--分页start-->
		<el-row type="flex" justify="end" align="middle" class="page" style="margin-top: 10px;margin-right: 50px;padding-bottom: 10px;">
			<el-pagination background layout="prev, pager, next" :current-page="pageNumber" :page-size="pageSize" :total="total" @current-change="changePage"></el-pagination>
			<span style="font-size: 13px;color: #999;">共 {{total}} 条</span>
		</el-row>
		<!--表格end-->

		<!--浏览图片的弹窗start-->
		<el-dialog :close-on-click-modal="false" width="400px" footer-hide title="预览" :visible.sync="isShowPreImg">
			<img :src="preImgUrl" style="width: 100%">
		</el-dialog>
		<!--浏览图片的弹窗end-->

		<!-- 添加品牌弹窗start -->
		<el-dialog :close-on-click-modal="false" width="600px" ref="form" custom-class="m-dialog" title="品牌信息" center :visible.sync="isShowAddOrEditTypePop">
			<div v-if="isShowAddOrEditTypePop">
				<div style="padding-top: 20px;">

					<el-form style="margin-left: 80px;" label-width="100px" size="small" ref="form" :rules="formRules" :model="form">


						<el-form-item label="品牌名称" prop="name">
							<el-input style="width: 250px;" v-model="form.name"></el-input>
						</el-form-item>

						<el-form-item label="品牌图片" prop="image" style="position: relative;">
							<div style="position: absolute;top: 20px;left: -59px;font-size: 12px;color: #aaa;">120*120</div>
							<upload-img :imgWidth="120" :imgHeight="120" :limit='1' accept="image/png" fileAfterName=".png" ref="fengMianUpload" :imgList="form.image"></upload-img>

						</el-form-item>

						<el-form-item label="品牌排序" prop="sort">
							<el-input style="width: 250px;" type="number" min="0" max="100" v-model="form.sort" placeholder="请输入0-100的排序值"></el-input>
						</el-form-item>



					</el-form>

				</div>
				<div class="dis" style="justify-content: flex-end;">

					<el-button round style="margin-left: 10px" @click="save('form')" type="primary" size="small">保存</el-button>
				</div>
			</div>
		</el-dialog>
		<!-- 添加品牌弹窗end -->


		<!-- 全屏透明的loading加载start -->
		<div id="pageLoading" v-if="loading" style="position: fixed;top:0;left: 0;width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;z-index: 999999;">
			<i class="el-icon-loading" style="font-size: 25px;"></i>
		</div>
		<!-- 全屏透明的loading加载end -->
	</div>
</template>

<script>
	import {
		ajax
	} from '../../util/ajax.js';
	import uploadImg from '../../components/upload/uploadImg.vue'

	export default {
		name: 'brand',
		components: {
			uploadImg
		},
		data() {
			return {
				mobileWidth:window.mobileWidth+170,
				isMobile:window.isMobile,
				
				storeList:[],//门店列表
				rowGoods_id: '', //列表项的商品id

				isShowCollapse: false, //是否展开搜索项
				searchForm: {
					status:1

				},

				isShowAddOrEditTypePop: false, //是否显示添加或编辑弹窗
				isShowPreImg: false, //是否显示浏览图片的弹窗
				preImgUrl: '', //浏览图片弹窗的图片地址


				tableHeight: 0, //表格高度
				loading: false,
				tableData: [], //表格数据
				pageNumber: 1, // 当前页数
				pageSize: 10, // 页面大小
				total: 0,

				shang: require("@/assets/shang.png"),
				xia: require("@/assets/xia.png"),
				sortIndex: -1, //排序项
				sortContent: '', //排序项的值 desc 或esc
				sortFlag: true, //排序箭头切换


				
				form: {
					brand_id:'',
					name: '',
					image: [],
					sort: 0
				},
				formRules: {

					name: [{
						required: true,
						message: '请输入品牌名称',
						trigger: 'blur'
					}],
					image: [{
						type: 'array',
						required: true,
						message: '请选择上传品牌图片',
						trigger: 'change'
					}],
					sort: [{
						required: true,
						message: '请输入0-100的排序值',
						trigger: 'blur',
						
					}]
				},



			}
		},

		filters: {
			//把 2021-07-30 11:07:36 格式为 07-30
			//								11:07
			//使用格式 <p>{{row.stateChangeTime | timeBreak(0)}}</p>    <p>{{row.stateChangeTime | timeBreak(1)}}</p> 
			timeBreak(time, type, from) {
				if (time) {
					return type == 0 ? (from == undefined ? time.substr(5, 5) : time.substr(0, 10)) : (type == 2 ? time
					.substr(0, 10) : (from == undefined ? time.substr(11, 5) : time.substr(11, 8)));
				} else {
					return time;
				}
			},

			timeBreak2(val) {

				let v = val.split(' ')[0];

				return v;
			},

		},
		created() {
			this.getTableHeight();
		},
		mounted() {

			//挂载window.onresize事件(动态设置table高度)
			let _this = this;
			window.onresize = () => {
				if (_this.resizeFlag) {
					clearTimeout(_this.resizeFlag);
				}
				_this.resizeFlag = setTimeout(() => {
					_this.getTableHeight();
					_this.resizeFlag = null;
				}, 100);
			};

			this.getStore();
			this.initData();
		},

		methods: {
			//获取门店列表
			async getStore(){
				let ress = await ajax('/hq/store', 'GET');
				let res = ress.data.data;
				this.storeList = res.store;
			},

			//初始化表格数据
			async initData() {
				this.loading = true
				var searchForm = this.searchForm
				let param = {

					 status:searchForm.status===""?null:searchForm.status,//搜索的 状态
					// mobile:searchForm.mobile,//搜索的 手机号

					count: this.pageSize,
					page: this.pageNumber
				}

				// if(searchForm.sort){
				// 	param.sort =searchForm.sort;//排序的属性名
				// 	param.sort_rule = searchForm.sort_rule;//排序的方式
				// }

				let ress = await ajax('/hq/brand', 'GET', param);
				this.loading = false;
				let res = ress.data.data;

				this.total = res.total;
				this.tableData = res.brand;
			},


			//计算table高度(动态设置table高度)
			getTableHeight() {
				let tableH = 245; //距离页面下方的高度,值越大表格高度越小
				let tableHeightDetil = window.innerHeight - tableH;
				if (tableHeightDetil <= 300) {
					this.tableHeight = 300;
				} else {
					this.tableHeight = window.innerHeight - tableH;
				}
			},
			//点击编辑
			showEditBrand(row){
				this.form.brand_id = row.id;
				this.form.name = row.name;
				this.form.image = [{url:row.image}];
				this.form.sort = row.sort;
				this.isShowAddOrEditTypePop = true;
			},
			//添加品牌弹窗
			showAddOrEditTypePop() {
				this.isShowAddOrEditTypePop = true;
			},
			
			//上下架
			async statusChange(row,status){
				
				let text = "确定下架吗？"
				if (status == 1) {
					text = "确定上架吗？"
				}
				
				this.$confirm(text, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					this.loading = true
					let ress = await ajax('/hq/brand', 'DELETE',{brand_id:row.id,status});
					this.loading = false;
					this.$message({
						type: 'success',
						message: '成功'
					});
					this.initData()
				}).catch(() => {
					this.loading = false;
				});
			},

			//保存
			async save(formName) {
				this.form.image = this.$refs.fengMianUpload.getImgList(); //商品封面图
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						
						if(this.form.sort<0||this.form.sort>100){
							this.$message.error('请填写0-100的排序值');
							return
						}
						
						let method="POST";
						if(this.form.brand_id){
							method='PUT'
						}
						this.loading = true;
						let ress = await ajax('/hq/brand', method, {
							brand_id:this.form.brand_id,
							name: this.form.name,
							image: this.form.image[0].url,
							sort: this.form.sort
						});
						this.loading = false;

						this.$refs[formName].resetFields();
						this.form= {
							brand_id:'',
							name: '',
							image: [],
							sort: 0
						};
						
						this.$message({
							message: '成功',
							type: 'success'
						});
						this.isShowAddOrEditTypePop = false;
						this.initData();
					} else {
						this.$message.error('请填写完整信息');
						return false;
					}
				});


			},

			//展开搜索项
			isShowCollapseF() {
				this.isShowCollapse = !this.isShowCollapse;
			},
			//翻页
			changePage(pageNumber) {
				console.log('即将翻到'+pageNumber+'页')
				
				this.tableData=[];//这种可以让滚动条回到顶部
				
				
				this.pageNumber = pageNumber
				this.initData()
			},

			//点击头像
			handlePreView(url) {
				this.preImgUrl = url
				this.isShowPreImg = true
			},


			//排序 index是点击的项的索引,formName是属性名
			sort(index, formName) {
				//点击了默认排序
				if (index == -1) {
					this.sortIndex = -1;
					this.sortContent = ''; //排序的值 desc / esc
					this.sortFlag = true;
					//使用index把所有的搜索项值为''然后再发送请求获取到默认列表
					this.pageNumber = 1; //页码修改为1
					this.tableData = []; //表格数据修改为空
					this.searchForm.sort = ''; //排序的属性名
					this.searchForm.sort_rule = ''; //排序的方式
					//获取默认排序的表格数据

					this.initData(); //获取默认排序的表格数据
					return
				}
				//点击还是当前搜索项那么就进行升降序切换
				if (index == this.sortIndex) {
					this.sortFlag = !this.sortFlag;
					//把当前点击的搜索项切换为desc为降序
					if (this.sortFlag) {
						this.sortContent = 'desc'; //排序的值 desc / esc
						//使用index把所有的搜索项值为''然后把当前点击的搜索项的值修改为desc
						this.pageNumber = 1; //页码修改为1
						this.tableData = []; //表格数据修改为空
						this.searchForm.sort = formName; //排序的属性名
						this.searchForm.sort_rule = 'desc'; //排序的方式
						//获取表格列表

						this.initData(); //获取当前点击的搜索项的表格数据
					} else {
						//把当前点击的搜索项切换为esc为升序
						//使用index把所有的搜索项值为''然后把当前搜索项的值修改为asc
						this.sortContent = 'asc'; //排序的值 desc / asc
						this.pageNumber = 1; //页码修改为1
						this.tableData = []; //表格数据修改为空
						this.searchForm.sort = formName; //排序的属性名
						this.searchForm.sort_rule = 'asc'; //排序的方式
						//获取表格列表
						this.initData(); //获取当前点击的搜索项的表格数据
					}
					return
				}
				//当前点击的搜索项是其他的搜索项
				this.sortIndex = index; //当前点击的搜索项的索引号
				this.sortContent = 'desc'; //排序的值 desc / esc
				this.sortFlag = true;
				//使用index把所有的搜索项值为''然后把当前搜索项的值修改为desc然后再发送请求获取到列表
				this.pageNumber = 1; //页码修改为1
				this.tableData = []; //表格数据修改为空
				this.searchForm.sort = formName; //排序的属性名
				this.searchForm.sort_rule = 'desc'; //排序的方式
				//获取表格列表

				this.initData(); //获取当前点击的搜索项的排序的表格数据
			},




			//搜索
			handleSearch() {
				this.pageNumber = 1;
				this.initData()
			},

			//重置
			handleReset() {
				this.$refs.searchForm.resetFields();
				this.searchForm = {
					status:1
				};
				this.sortIndex = -1;
				this.sortContent = ''; //排序的值 desc / esc
				this.sortFlag = true;
				this.pageNumber = 1
				this.pageSize = 10
				this.tableData = []; //表格数据修改为空
				this.initData()
			},






		}


	}
</script>

<style scoped>
	.tableTem ul {
		width: 100%;
		overflow: hidden;
		display: flex;
		flex-wrap: wrap;

	}

	.tableTem ul li {
		list-style: none;

		width: 110px;
		min-height: 60px;
		border-left: 1px solid #ededed;
		border-bottom: 1px solid #ededed;
		margin-bottom: -1px;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		padding: 3px;


	}

	.tableTem .content {

		padding-top: 3px;
		font-size: 14px;
		color: #2d8cf0;
		font-weight: 600;
	}

	.tableTem .avatar img {
		border-radius: 10px;
		width: 60px;
		height: 60px;
	}

	.tableTem .avatar {

		padding-right: 20px;
		display: flex;
		justify-content: center;

	}

	.tableTem .dian {
		text-align: center;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 100px;
	}

	.tableTem .dianL {
		text-align: left;
		font-size: 13px;
		color: #333;
	}


	.titleFont {
		font-size: 12px !important;
		flex-shrink: 0;
		line-height: 25px;
		color: rgb(136, 136, 136);
	}





	.sortLine {
		display: flex;
		align-items: center;
	}

	.sortItem {

		height: 100%;
		color: rgb(156, 156, 156);
		text-align: center;
		line-height: 30px;
		cursor: pointer;
		min-width: 80px;
	}

	.sortItem:hover {
		background-color: #9E819F !important;
		color: #fff !important;
	}

	.sortLine .sortItem:last-child {
		border-right: none;
	}

	>>>.el-table tbody tr:hover>td {
		background-color: #ffffff !important
	}


	>>>.el-icon-arrow-down {
		font-size: 12px;
	}

	>>>.demonstration {
		display: block;
		color: #8492a6;
		font-size: 14px;
		margin-bottom: 20px;
	}

	>>>.el-dropdown-link {
		cursor: pointer;
		color: #409EFF;
	}

	>>>.el-table td {
		padding: 10px 0 !important;
	}
</style>
